import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useIr3PrisonRecalls(options) {
  const searchParams = JSON.parse(JSON.stringify(options ?? {}));

  return useQuery({
    queryKey: ['ir3PrisonRecalls', searchParams],
    queryFn: () => {
      return briefingApi.get('prisonRecalls', { searchParams }).json();
    },
    placeholderData: [],
    staleTime: 15 * (60 * 1000),
    cacheTime: 20 * (60 * 1000),
    keepPreviousData: true,
  });
}
